import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBan,
  faCheck,
  faCircleNotch,
  faPause,
  faTriangleExclamation,
} from "@fortawesome/pro-regular-svg-icons";

import type {
  ActiveSubstatus,
  StoppedSubstatus,
} from "src/api/agents/execution";
import { Pill, PillVariants } from "src/design-system/Pill";

export type AgentStatusSubstatus = ActiveSubstatus | StoppedSubstatus;

const RUNNING_PILL_CONFIG = {
  variant: "indigo-light" as PillVariants,
  icon: faCircleNotch,
  label: "Running",
};

export const AGENT_STATUS_PILL_CONFIG: Record<
  AgentStatusSubstatus,
  { variant: PillVariants; icon: IconDefinition; label: string }
> = {
  success: { variant: "green", icon: faCheck, label: "Successful" },
  failed: { variant: "red", icon: faTriangleExclamation, label: "Failed" },
  running: RUNNING_PILL_CONFIG,
  pending: RUNNING_PILL_CONFIG,
  booting: RUNNING_PILL_CONFIG,
  paused: { variant: "yellow", icon: faPause, label: "Waiting for tools" },
  cancelling: { variant: "gray", icon: faCircleNotch, label: "Cancelling" },
  cancelled: { variant: "gray", icon: faBan, label: "Cancelled" },
};

export const AgentStatusPill: React.FC<{
  substatus: AgentStatusSubstatus;
  spin?: boolean;
  dataLoc?: string;
}> = ({ substatus, spin = false, dataLoc }) => {
  const config = AGENT_STATUS_PILL_CONFIG[substatus];
  return (
    <Pill dataLoc={dataLoc} size="sm" variant={config.variant} maxWidth>
      <Pill.Icon icon={config.icon} spin={spin} />
      <Pill.Text>{config.label}</Pill.Text>
    </Pill>
  );
};
